/*
 * @Description: 
 * @Version: 
 * @Autor: 
 * @Date: 2022-04-19 08:45:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-24 10:59:25
 */
import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
//お仕事案内一覧検索
export const i_0017_search = (month, userCd) => {
  return http.requestGet(apiUrl.apiUrl_jobIntroSearch + '?yearMonth=' + month + '&jobIntroStaffCode=' + userCd)
}
//お仕事選択一覧検索
export const i_0017_select_search = (jobDate, jobSelectStaffCode) => {
  return http.requestGet(apiUrl.apiUrl_jobSelectSearch + '?jobDate=' + jobDate + '&jobSelectStaffCode=' + jobSelectStaffCode)
}
//お仕事詳細一覧検索
export const i_0017_detail_search = (fieldCode, recruitNo) => {
  return http.requestGet(apiUrl.apiUrl_jobDetailSearch + '?fieldCode=' + fieldCode + '&recruitNo=' + recruitNo)
}
//お仕事申請一覧検索
export const i_0017_apply_search = (jobApplyStaffCode, yearMonth, fieldCode, recruitNo) => {
  return http.requestGet(apiUrl.apiUrl_jobApplySearch + '?jobApplyStaffCode=' + jobApplyStaffCode + '&yearMonth=' + yearMonth + '&fieldCode=' + fieldCode + '&recruitNo=' + recruitNo)
}
//お仕事申請保存
export const i_0017_apply_update = (params) => {
  return http.requestPost(apiUrl.apiUrl_jobApplyUpdate, params)
}
export const i_0015_update = (params, userCd) => {
  return http.requestPost(apiUrl.apiUrl_holidaySave + '?userCd=' + userCd, params)
}


// WEBPACK FOOTER //
// ./src/module/api/i_0017.js